import React, { useEffect, useRef, useState } from "react";
import PageLayout from "../../layout/PageLayout/pageLayout";
import share from "../../include/images/share.svg";
import noRecord from "../../include/images/nrb-img.svg";
import audio from "../../include/images/audio.svg";
import explore from "../../include/images/explore-img.png";
import { connect } from "react-redux";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import { getUserStoryDetail, userStoryData } from "../../store/userStory";
import LoadingBar from "react-top-loading-bar";
import { toast } from "react-toastify";
import AlertError from "../../common/alerts/alertError";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Skeleton from "react-loading-skeleton";
import ShareModal from "../../components/common/sharemodal/shareModal";
import { capitalizeContentInBrackets, capitalizeFirstLetterWord } from "../../utils/helperFunctions";
import { Dropdown } from "react-bootstrap";
import { getDefaultImage } from "../../common/defaultImages/speciesDefaultImage";

const CustomerStoryDetail = (props) => {
  const location = useLocation();
  const ref = useRef();
  const pageRef = useRef();
  const storyData = props?.userStoryData?.storyDetail?.data;
  const [loading, setLoading] = useState(true);
  const [showShareModal, setShowShareModal] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPreviewPage, setIsPreviewPage] = useState(false);

  const speakWholePage = () => {
    const text = storyData?.mainStory;

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US"; // Customize language if needed

    // Optional settings
    utterance.pitch = 1;
    utterance.rate = 1;
    utterance.volume = 1;

    speechSynthesis.cancel(); // Cancel any previous speech
    speechSynthesis.speak(utterance);
    setIsPlaying(true);
  };

  const stopSpeaking = () => {
    speechSynthesis.cancel(); // this will immediately stop any speaking
    setIsPlaying(false);
  };

  const toggleShareModal = () => {
    setShowShareModal((prev) => !prev);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    ref?.current?.continuousStart();
    const page = location?.pathname === "/user-story-preview" ? "preview" : "published";

    const slug = page === "preview" ? location?.state?.slug : location?.pathname?.split("/")?.[2];

    if (page === "preview") {
      setIsPreviewPage(true);
    }

    if (!slug) return;
    props?.getUserStoryDetail({}, slug, (res) => {
      setLoading(false);
      ref?.current?.complete();
      if (res?.status != 200) {
        toast(<AlertError message={res?.data?.message || "Something went wrong!!"} />);
      }
    });
  }, []);

  const getShareUrl = (slug) => {
    const baseUrl =
      process.env.REACT_APP_MODE === "development"
        ? "https://www.dev.environmentalinclusion.com/user-story"
        : "https://www.environmentalinclusion.com/user-story";
    return `${baseUrl}/${encodeURIComponent(slug)}`;
  };

  return (
    <>
      <LoadingBar height={5} color="#47AD1D" ref={ref} />
      <PageLayout>
        <div class="content-container single-story-container" ref={pageRef}>
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="ss-content-box">
                  {loading ? (
                    <Skeleton height={"20px"} className="mb-3" width="250px" />
                  ) : (
                    <div class="breadcrumb-row d-flex flex-wrap">
                      <div class="breadcrumb-box">
                        <Link to="/">Home</Link>
                      </div>
                      <div class="breadcrumb-box">
                        <Link to="/environmental-stories">Stories</Link>
                      </div>
                      <div class="breadcrumb-box">
                        <a href="javascript:void(0)">{storyData?.title}</a>
                      </div>
                    </div>
                  )}
                  {loading ? <Skeleton height="35px" /> : <h1>{storyData?.title}</h1>}
                  <div class={`ss-label-box d-flex flex-column ${loading ? "mt-3" : ""}`}>
                    {loading ? <Skeleton height="35px" /> : <div class="ss-label-upper">{storyData?.contributor}</div>}
                  </div>

                  <div class={`ss-share-box d-flex align-items-center ${isPreviewPage && "ss-share-box-1"}`}>
                    <div class="ss-share-left">
                      {loading ? (
                        <Skeleton height={"40px"} width={"40px"} />
                      ) : (
                        !isPreviewPage && (
                          // <a href="javascript:void(0)" onClick={() => toggleShareModal()} class="ss-share-img">
                          //   <img src={share} alt="" />
                          // </a>
                          <Dropdown as="a">
                            <Dropdown.Toggle as={"div"} className="ss-share-icon">
                              <img src={share} alt="" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-menu share-post">
                              <FacebookShareButton
                                url={getShareUrl(storyData?.slug)}
                                description={storyData?.description}
                                className="custom-share-post"
                              >
                                <Dropdown.Item className="dropdown-item" eventKey={"1"}>
                                  <Link
                                    to="#"
                                    className="dropdown-item-link w-100 h-100 d-flex flex-wrap align-items-center"
                                  >
                                    <div className="dropdown-item-icon d-flex flex-wrap align-items-center justify-content-center">
                                      <svg
                                        width="20"
                                        height="21"
                                        viewBox="0 0 20 21"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M10.7974 16.1444V10.7915H12.5942L12.8637 8.70543H10.7974V7.37352C10.7974 6.76958 10.9652 6.35797 11.8313 6.35797H12.936V4.49269C12.4013 4.43612 11.8639 4.40872 11.3263 4.41061C9.73351 4.41061 8.64314 5.38274 8.64314 7.16813V8.70543H6.8418V10.7915H8.64314V16.1444H10.7974Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </div>

                                    <div className="dropdown-item-text custom-share-dropdown-text">Facebook</div>
                                  </Link>
                                </Dropdown.Item>
                              </FacebookShareButton>
                              <TwitterShareButton url={getShareUrl(storyData?.slug)} className="custom-share-post">
                                <Dropdown.Item className="dropdown-item" eventKey={"2"}>
                                  <Link
                                    to="#"
                                    className="dropdown-item-link w-100 h-100 d-flex flex-wrap align-items-center"
                                  >
                                    <div className="dropdown-item-icon d-flex flex-wrap align-items-center justify-content-center">
                                      <svg
                                        width="20"
                                        height="21"
                                        viewBox="0 0 20 21"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M3.0317 5L8.05085 11.6187L3 17H4.13674L8.55875 12.2886L12.1316 17H16L10.6984 10.009L15.3997 5H14.263L10.1905 9.33911L6.90008 5H3.0317ZM4.70336 5.8258H6.48051L14.3281 16.1741H12.5509L4.70336 5.8258Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </div>

                                    <div className="dropdown-item-text custom-share-dropdown-text">Twitter</div>
                                  </Link>
                                </Dropdown.Item>
                              </TwitterShareButton>
                            </Dropdown.Menu>
                          </Dropdown>
                        )
                      )}
                    </div>
                    {loading ? (
                      <Skeleton className="ml-3" height={"40px"} width={"150px"} />
                    ) : (
                      <button type="button" class="ss-share-right d-flex align-items-center">
                        <img class="ss-volume-img" src={audio} alt="" />
                        <div class="ss-share-text" onClick={isPlaying ? stopSpeaking : speakWholePage}>
                          Listen to this story
                        </div>
                      </button>
                    )}
                  </div>

                  <div class="ss-img-text-box">
                    <div class="row">
                      <div class="col-lg-6">
                        {loading ? (
                          <Skeleton height={"340px"} />
                        ) : (
                          <div class="ss-img-box ss-object-contain">
                            <img src={process.env.REACT_APP_MEDIA + storyData?.featuredImage?.[0]?.original} alt="" />
                          </div>
                        )}
                      </div>
                      <div class="col-lg-6">
                        <div class="ss-text-box" style={{ whiteSpace: "pre-line" }}>
                          {loading ? (
                            <Skeleton height={"20px"} count={"15"} />
                          ) : (
                            <p>
                              {storyData?.mainStory?.length > 900
                                ? storyData?.mainStory?.slice(0, 900)
                                : storyData?.mainStory}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {!loading && storyData?.mainStory?.length > 900 && (
                    <div class="ss-text-box" style={{ whiteSpace: "pre-line" }}>
                      <p>{storyData?.mainStory?.slice(900)}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-container ss-media-container ss-pt-0">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <div class="sss-media-content-box">
                  <h2>Species</h2>
                  <div class="us-ss-list ss-list d-flex flex-wrap">
                    <div class="container">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="tbc-body-inner ss-tbc-body-inner">
                            <ul class="ei-grid-list region-species-list d-flex flex-wrap ei-grid-5">
                              {loading
                                ? [1, 2, 3, 4, 5, 2, 4]?.map((item) => (
                                    <div class="ss-item user-story-ss-item">
                                      <div class="ss-box">
                                        <div class="ss-img">
                                          <Skeleton height={"180px"} />
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                : storyData?.species?.map((item) => (
                                    <li class="ei-grid-item">
                                      <a href={`/endangered-species/${item?.slug}`} target="_blank" class="ei-grid-box">
                                        <div class="ei-grid-box-image">
                                          {item?.coverImage?.original ? (
                                            <img
                                              src={process.env.REACT_APP_MEDIA + item?.coverImage?.original}
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = getDefaultImage(item?.speciesCategoryName);
                                              }}
                                              alt=""
                                            />
                                          ) : (
                                            <img src={getDefaultImage(item?.speciesCategoryName)} alt="" />
                                          )}
                                        </div>
                                        <div class="ei-grid-box-overlay">
                                          <p>{capitalizeFirstLetterWord(item?.displayCommonName)}</p>{" "}
                                        </div>
                                      </a>
                                    </li>
                                  ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    {storyData?.species.length === 0 && (
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <img src={noRecord} alt="" />
                          <p>No Media Found</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
        <div class="content-container ss-media-container ss-pt-0">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <div class="sss-media-content-box">
                  <h2>Photos and Videos</h2>
                  <div class="us-ss-list ss-list d-flex flex-wrap">
                    {loading
                      ? [1, 2, 3, 4, 5, 2, 4]?.map((item) => (
                          <div class="ss-item user-story-ss-item">
                            <div class="ss-box">
                              <div class="ss-img">
                                <Skeleton height={"180px"} />
                              </div>
                            </div>
                          </div>
                        ))
                      : [...storyData?.featuredImage, ...storyData?.files]?.map((item) => (
                          <div class="ss-item user-story-ss-item">
                            <div class="ss-box">
                              <div class="ss-img">
                                {item?.mediaType === "image" ? (
                                  <img src={process.env.REACT_APP_MEDIA + item?.original} alt="" />
                                ) : (
                                  <video width="100%" controls>
                                    <source
                                      src={process.env.REACT_APP_MEDIA + item?.original}
                                      // type={item?.original?.split(".")?.[1]}
                                    />
                                    Your browser does not support the video tag.
                                  </video>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                    {!loading && [...storyData?.featuredImage, ...storyData?.files].length === 0 && (
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <img src={noRecord} alt="" />
                          <p>No Media Found</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
        <div class="content-container explore-container bg-green ">
          <div class="container">
            <div class="row">
              <div class="col-lg-5 pe-lg-5">
                <div class="explore-img-box">
                  <img src={explore} alt="" />
                </div>
              </div>
              <div class="col-lg-7">
                <div class="explore-content-box d-flex flex-column justify-content-center">
                  <h4>Explore More</h4>
                  <p>
                    To read more about this species and 14,000 other species around the world come to our website,
                    register and explore more courageous stories like this one.
                  </p>
                  <a href="/" class="link-label-btn">
                    Pick an Animal and Save It
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageLayout>
      <ShareModal
        show={showShareModal}
        onHide={toggleShareModal}
        name={capitalizeContentInBrackets(capitalizeFirstLetterWord(storyData?.title))}
        id={storyData?._id}
        category="story"
      />
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getUserStoryDetail: (params, id, callback) => dispatch(getUserStoryDetail(params, id, callback)),
});

const mapStateToProps = (state) => ({
  userStoryData: userStoryData(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(CustomerStoryDetail));
